
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[slug]",
      function () {
        return require("private-next-pages/products/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[slug]"])
      });
    }
  